import { render, staticRenderFns } from "./StatsControls.vue?vue&type=template&id=5bc5da85&scoped=true&"
import script from "./StatsControls.vue?vue&type=script&lang=js&"
export * from "./StatsControls.vue?vue&type=script&lang=js&"
import style0 from "./StatsControls.vue?vue&type=style&index=0&id=5bc5da85&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc5da85",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bc5da85')) {
      api.createRecord('5bc5da85', component.options)
    } else {
      api.reload('5bc5da85', component.options)
    }
    module.hot.accept("./StatsControls.vue?vue&type=template&id=5bc5da85&scoped=true&", function () {
      api.rerender('5bc5da85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/StatsControls.vue"
export default component.exports